import { render, staticRenderFns } from "./todoDetailsOpinions.vue?vue&type=template&id=09cf5a92&"
import script from "./todoDetailsOpinions.vue?vue&type=script&lang=js&"
export * from "./todoDetailsOpinions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports